import React from 'react';
import { FileText, Users, Package } from 'lucide-react';
import { t } from '../i18n';

const icons = [FileText, Users, Package];

export default function ProductSection({ lang }) {
  const c = t(lang);

  return (
    <section id="producto" className="relative py-20 md:py-28 bg-[#EEF4F2]">
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#0C3C3C]/8 to-transparent pointer-events-none" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#0C3C3C] tracking-tight mb-3">
            {c.product.title}
          </h2>
          <p className="text-lg text-teal-900/65 leading-relaxed">{c.product.lead}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {c.product.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div key={item.title} className="group">
                <div className="w-12 h-12 mb-5 flex items-center justify-center rounded-md bg-[#0C3C3C] text-teal-300 transition-transform duration-300 group-hover:-translate-y-1">
                  <Icon size={22} strokeWidth={2} />
                </div>
                <h3 className="font-display text-xl font-bold text-[#0C3C3C] mb-2">
                  {item.title}
                </h3>
                <p className="text-teal-900/65 leading-relaxed mb-4">{item.text}</p>
                <a
                  href="/s"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-800 hover:text-teal-950 underline-offset-4 hover:underline"
                >
                  {item.cta}
                  <span aria-hidden="true">→</span>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
